import * as React from "react";
const SvgArrowsExpandLeft = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.10046 2.10059V0.100586H0.100464L0.100464 8.10059H2.10046L2.10046 3.51477L7.87875 9.29305L9.29296 7.87884L3.51471 2.10059H8.10046Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.8995 11.8995H19.8995V19.8995H11.8995V17.8995H16.4853L10.7071 12.1213L12.1213 10.7071L17.8995 16.4853V11.8995Z",
	fill: "black"
}));
export default SvgArrowsExpandLeft;
